<template>
    <a-modal
        :visible="!!announcement"
        :maskClosable="false"
        :keyboard="true"
        centered
        :width="640"
        wrapClassName="announcements-modal"
        @cancel="$emit('close')"
    >
        <template slot="title">
            <span v-if="announcement" class="announcements-modal-title">
                {{ announcement.title }}
                <small v-if="queueLabel" class="announcements-queue">{{ queueLabel }}</small>
            </span>
        </template>
        <!-- Aviso de imagem: só a imagem. Sem `type` (kyojin antigo) é texto. -->
        <div
            v-if="announcement && announcement.type === 'IMAGE' && announcement.image_url"
            class="announcements-content announcements-content--image"
        >
            <img class="announcements-image" :src="announcement.image_url" :alt="announcement.title" />
        </div>
        <!-- Conteúdo já sanitizado pelo kyojin. -->
        <div
            v-else-if="announcement"
            class="announcements-content"
            v-html="announcement.content"
        />
        <template slot="footer">
            <a-button type="primary" @click="$emit('close')">Fechar</a-button>
        </template>
    </a-modal>
</template>

<script>
export default {
    name: "AnnouncementModal",
    props: {
        announcement: { type: Object, default: null },
        queueLabel: { type: String, default: null },
    },
};
</script>

<style>
.announcements-modal-title {
    display: inline-flex;
    align-items: baseline;
    gap: 8px;
}
.announcements-queue {
    color: #8c8c8c;
    font-weight: 400;
}
.announcements-content {
    max-height: 60vh;
    overflow-y: auto;
    word-break: break-word;
}
.announcements-content img {
    max-width: 100%;
}
.announcements-content--image {
    display: flex;
    justify-content: center;
}
.announcements-image {
    display: block;
    max-height: 60vh;
    object-fit: contain;
    border-radius: 8px;
}
</style>
